import { Chip } from "@mui/material"
import css from './AceptaChip.module.css'

const AceptaChip = ()=> (
  <Chip 
    size='small' 
    className={css.chip} 
    color="primary" 
    variant="outlined" 
    icon={<i className='material-icons'>check</i>} 
    label="Aceptado" 
  />
)

export default AceptaChip